export default new class cookiesComponent {
  constructor() {
    this.cookiesWrapper = 'cookie-wrapper';
    this.closePopup = '_cookie-close';
    this.delay = 800;
    this.delayClose = 800;

    this.init();
    this.close();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      if (localStorage.getItem('hide-cookie') !== 'hide') {
        this.load();
      }
    });
  }

  load() {
    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.cookiesWrapper);
    body.append(div);

    $.request('onAjax', {
      update: {
        'common/cookies/cookies': `.${this.cookiesWrapper}`,
      },
    });
  }

  close() {
    $(document)
      .on('click', `.${this.closePopup}`, () => {
        localStorage.setItem('hide-cookie', 'hide');
        $(`.${this.cookiesWrapper}`)
          .delay(this.delayClose)
          .fadeOut('slow');
      });
  }
}();
